import Collapse from './Collapse';

export default Collapse;
export var Panel = Collapse.Panel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-collapse@1.10.0@rc-collapse/es/index.js
// module id = 276
// module chunks = 0 1